<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'up-document.file'">
      _Subir documentos
    </span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content-scroll">
    @if(uploadDocuments.failedUploads.length > 0){
      <p class="common-modal__content-header-info"
        [afTranslate]="'common.upload-documents-modal-error'">
        _No se han podido subir algunos documentos. Si quieres, puedes intentarlo de nuevo antes de continuar.
      </p>
    }
    <div class="upload-document__form-container">
      @if(!uploadDocuments.updating && uploadDocuments.failedUploads.length === 0){
        <div class="upload-document__upload-block"
          dropZone
          (fileDropped)="dropNewDocument($event)">
          <div class="upload-document__upload-inner-block">
            <i class="lf-icon-up-file common-icon__lg common-icon__main"></i>
            <div class="upload-document__upload-text-block">
              <p class="upload-document__upload-text landing-page__desktop"
                [afTranslate]="'up-document.drag-documents'">
                _Arrastra aquí tus documentos o
              </p>
              <button class="common-button__link">
                <a class="common-button__link-text"
                  [afTranslate]="'record-audio-modal.discard-record'"
                  (click)="openFileSearch()"
                  [afTranslate]="'documentation-list.explore-pc'">
                  _Explora en tu dispositivo
                </a>
              </button>
              <input class="upload-document__file-upload" id="fileDropRef"
                type="file"
                multiple
                (change)="loadFiles($event)"/>
            </div>
          </div>
        </div>
      }
      <div class="upload-document__upload-list-items-container">
        <div class="upload-document__upload-list-container">
          <div class="upload-document__upload-list-inner-container">
            <p class="upload-document__title-text"
              [afTranslate]="'up-document.select-document'">
              _Documentos seleccionados
            </p>
            <div class="common-badge__badge-block">
              <span class="common-badge__square-md">{{uploadDocuments.upDocuments.length}}</span>
            </div>
          </div>
        </div>
        <ul class="upload-document__upload-list-items">
          @for (document of uploadDocuments.upDocuments; track $index) {
            <li class="upload-document__upload-item-block">
              <div class="upload-document__upload-item"
                [ngClass]="{'upload-document__upload-item--error':document.status==='error' || document.status==='validate-error'}">
                <div class="upload-document__upload-item-container">
                  <div [class]="(document.source | extensionDocument)+' common-icon__md'">
                  </div>
                  <div class="upload-document__text-container">
                    <span-tooltip class="upload-document__text"
                      [text]="document.name"></span-tooltip>
                    <p class="upload-document__text upload-document__text--dimension">
                      {{document.size | convertBytes}}
                    </p>
                  </div>
                  @if(!uploadDocuments.updating){
                    <div class="upload-document__container-upload-item-buttons">
                      <div class="upload-document__upload-item-buttons">
                        @if(document.status!=='error'){
                          <button class="common-button__icon-md-noborder"
                            (click)="renameDocument(document)">
                            <i class="lf-icon-rename common-icon__md"></i>
                          </button>
                        }@else {
                          <button class="common-button__icon-md-noborder"
                            (click)="addDocument(document, true)">
                            <i class="lf-icon-rotate common-icon__md"></i>
                          </button>
                        }
                        <button class="common-button__icon-md-noborder"
                          (click)="deleteDocument($index)">
                          <i class="lf-icon-trash common-icon__md"></i>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </div>
              @if(uploadDocuments.updating && document.progress > 0){
                <div class="common-progress-indicator__bar-block h-[4px]">
                  <div class="common-progress-indicator__bar-inner"
                    [ngStyle]="{'width': document.progress+'%'}">
                  </div>
                </div>
              }@else if (!uploadDocuments.updating && (document.status==='error' || document.status==='validate-error')) {
                <div class="upload-document__item-block-error">
                  <p class="upload-document__text upload-document__text--error">{{document.statusText}}</p>
                </div>
              }
            </li>
          }
        </ul>
      </div>
      @if(uploadDocuments.showProcess && type !== 'dropFiles' && !uploadDocuments.updating && !uploadDocuments.complete){
        <div class="common-modal__form-container">
          @if (uploadDocuments.processSteps.required) {
            <div class="common-container__mandatory-obligatory-message-form">
              <span class="common-tag__mandatory-text-asterisk">*</span>
              <span class="common-tag__mandatory-label-text-obligatory-message"
                [afTranslate]="'common.required-fields'">
                _Campos obligatorios
              </span>
            </div>
          }
          <field-type-list-simple [field]="uploadDocuments.processSteps"
            [listValues]="listSelect"
            [preSelectItem]="uploadDocuments.stateId"
            (itemSelected)="itemSelectedList($event, 'stateId')">
          </field-type-list-simple>
        </div>

      }
      @if (type === 'addNewDocumentsFromTasks' && !uploadDocuments.updating) {
        <field-type-text-multiline [field]="uploadDocuments.addCommentField"
          [preSelectItem]="uploadDocuments.comments"
          (itemSelected)="uploadDocuments.comments = $event.newValue">
        </field-type-text-multiline>
      }
    </div>

  </div>
  @if(uploadDocuments.newConceptLanding && uploadDocuments.upDocuments.length  && !uploadDocuments.updating && !uploadDocuments.complete){
    <advice-message
      [type]="'info'"
      [text]="uploadDocuments.textInfo"
      [showCloseButton]="false">
    </advice-message>
  }
  <div class="common-modal__footer">
    @if(!uploadDocuments.updating && uploadDocuments.failedUploads.length === 0){
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.discard'">Descartar
        </span>
      </button>
      <button class="common-button__text"
        [ngClass]="{'common-button__text--disabled': uploadDocuments.documentsWithError > 0 || uploadDocuments.upDocuments.length === 0}"
        (click)="uploadFiles()"
        [disabled]="uploadDocuments.documentsWithError > 0 || uploadDocuments.upDocuments.length === 0">
        <span class="common-button__text-title"
          [afTranslate]="'common.add'">
          _Añadir
        </span>
      </button>
    }@else if(uploadDocuments.complete){
      <button class="common-button__text"
        (click)="handleAccept()">
        <span class="common-button__text-title"
          [afTranslate]="'common.continue'">
          _continuar
        </span>
      </button>
    }
  </div>
</div>
